
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export function SectionHeader({ icon: Icon, title, subtitle, linkTo, linkText = "MORE" }) {
  return (
    <div className="w-full flex flex-col sm:flex-row gap-4 sm:gap-0 justify-between items-center">
      {/* Title & Link Block */}
      <div className="w-full flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 sm:gap-6 text-center sm:text-left">
        <div className="flex flex-col gap-1">
          <h2 className="text-xl sm:text-2xl font-bold text-slate-800 dark:text-white">{title}</h2>
          <p className="text-slate-500 dark:text-slate-400">{subtitle}</p>
        </div>

        {linkTo && (
          <Link 
            to={linkTo}
            className="flex justify-center sm:justify-end items-center gap-2 text-blue-600 dark:text-blue-400 hover:text-blue-500 dark:hover:text-blue-300 transition-colors font-medium"
          >
            <div className="text-slate-800 text-xs">{linkText}</div>
            <div tabIndex="0" className="plusButton">
              <svg className="plusIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                <g mask="url(#mask0_21_345)">
                  <path d="M13.75 23.75V16.25H6.25V13.75H13.75V6.25H16.25V13.75H23.75V16.25H16.25V23.75H13.75Z"></path>
                </g>
              </svg>
            </div>
          </Link>
        )}
      </div>
    </div>
  );
}
